// Chapter 1 Quiz Questions (1-15)

export const ch1Quiz1 = [
  {
    question: "What is the PRIMARY purpose of crop insurance?",
    options: [
      "To guarantee farmers a profit every year",
      "To transfer the financial consequences of risk from farmers to the insurance system",
      "To eliminate all risk from farming operations",
      "To provide loans to agricultural producers"
    ],
    correct: 1,
    explanation: "Crop insurance transfers risk from individual farmers to a larger pool. It doesn't guarantee profits or eliminate risk—it provides financial protection against unavoidable losses."
  },
  {
    question: "Crop insurance in the United States operates through what type of system?",
    options: [
      "Entirely private market with no government involvement",
      "Entirely government-run with no private companies",
      "Public-private partnership with government subsidies and private delivery",
      "State-run programs with no federal involvement"
    ],
    correct: 2,
    explanation: "Crop insurance is a public-private partnership. Private AIPs sell policies while the federal government sets rules, subsidizes premiums, and provides reinsurance."
  },
  {
    question: "Which type of risk is insurable?",
    options: [
      "Speculative risk",
      "Pure risk",
      "Market risk",
      "Investment risk"
    ],
    correct: 1,
    explanation: "Pure risk (only possibility of loss or no loss) is insurable. Speculative risk (possibility of gain, loss, or breaking even) is NOT insurable."
  },
  {
    question: "A farmer decides not to scout fields for pests because 'insurance will cover any damage anyway.' This is an example of:",
    options: [
      "Physical hazard",
      "Moral hazard",
      "Morale hazard",
      "Pure risk"
    ],
    correct: 2,
    explanation: "Morale hazard is carelessness or indifference because insurance exists. Moral hazard involves intentional dishonesty, while physical hazard is a physical condition."
  },
  {
    question: "A farmer intentionally underreports production history to receive a higher guarantee. This is an example of:",
    options: [
      "Physical hazard",
      "Moral hazard",
      "Morale hazard",
      "Speculative risk"
    ],
    correct: 1,
    explanation: "Moral hazard is intentional dishonesty to cause or exaggerate a loss. Deliberately underreporting history to inflate guarantees is fraudulent behavior."
  },
  {
    question: "What is a 'peril' in insurance terminology?",
    options: [
      "A condition that increases the likelihood of loss",
      "The actual cause of loss",
      "The amount of coverage selected",
      "The premium charged for coverage"
    ],
    correct: 1,
    explanation: "A peril is the actual cause of loss (drought, hail, frost, etc.). A hazard is a condition that increases likelihood of loss."
  },
  {
    question: "The principle of indemnity states that insurance should:",
    options: [
      "Provide profit to the insured after a loss",
      "Restore the insured to the same financial position before the loss",
      "Pay the full value of all property regardless of damage",
      "Cover all risks without exception"
    ],
    correct: 1,
    explanation: "Indemnity restores the insured to their pre-loss financial position—no better and no worse. Insurance is not designed to create profit."
  },
  {
    question: "In a 60/40 share rent arrangement, the tenant can insure what percentage of the crop?",
    options: [
      "100%",
      "60%",
      "40%",
      "50%"
    ],
    correct: 1,
    explanation: "Each party can only insure their own share. In a 60/40 arrangement, the tenant has insurable interest in 60% and the landlord in 40%."
  },
  {
    question: "What is 'insurable interest'?",
    options: [
      "The interest rate charged on crop insurance premiums",
      "A financial stake in the property or outcome being insured",
      "The profit margin for insurance companies",
      "The amount of coverage selected"
    ],
    correct: 1,
    explanation: "Insurable interest means having a financial stake in what you're insuring. You cannot insure property in which you have no financial interest."
  },
  {
    question: "Which valuation method equals replacement cost minus depreciation?",
    options: [
      "Market value",
      "Stated value",
      "Actual cash value (ACV)",
      "Salvage value"
    ],
    correct: 2,
    explanation: "ACV = Replacement Cost − Depreciation. It accounts for the current, used condition of property."
  },
  {
    question: "Multi-Peril Crop Insurance (MPCI) covers which type of loss?",
    options: [
      "Indirect losses like lost profits",
      "Direct losses to growing crops from insured perils",
      "All losses regardless of cause",
      "Only losses from hail damage"
    ],
    correct: 1,
    explanation: "MPCI covers direct losses to growing crops from insured perils. It does NOT cover indirect/consequential losses like lost profits."
  },
  {
    question: "What is subrogation?",
    options: [
      "The insured's right to sue the insurance company",
      "The insurer's right to pursue recovery from a third party who caused the loss",
      "The process of canceling an insurance policy",
      "The method of calculating premiums"
    ],
    correct: 1,
    explanation: "Subrogation allows the insurer to 'step into the shoes' of the insured and pursue the party responsible for the loss after paying a claim."
  },
  {
    question: "What is the primary role of Approved Insurance Providers (AIPs)?",
    options: [
      "Set crop insurance policy terms",
      "Provide premium subsidies to farmers",
      "Sell and service federal crop insurance policies",
      "Regulate crop insurance agents"
    ],
    correct: 2,
    explanation: "AIPs are private companies that sell policies, collect premiums, and process claims. FCIC/RMA sets terms; government provides subsidies."
  },
  {
    question: "The Federal Crop Insurance Act of 1980 is significant because it:",
    options: [
      "Created the first crop insurance program in U.S. history",
      "Eliminated all premium subsidies",
      "Introduced premium subsidies and the public-private delivery system",
      "Transferred crop insurance entirely to state governments"
    ],
    correct: 2,
    explanation: "The 1980 Act created modern crop insurance with premium subsidies and private AIPs delivering policies. Earlier programs existed but were limited."
  },
  {
    question: "Which organization develops standard policy forms for private crop hail insurance?",
    options: [
      "Risk Management Agency (RMA)",
      "Federal Crop Insurance Corporation (FCIC)",
      "National Crop Insurance Services (NCIS)",
      "South Dakota Division of Insurance"
    ],
    correct: 2,
    explanation: "NCIS provides services for private crop hail insurance, including standard policy forms. RMA/FCIC handle federal MPCI programs."
  }
];
